import type { UserStatus } from '../../constants/Constants';
import type { sizeOfPortfolio } from '../../features/Registration/constants/UnitOptions';
import type { Permission } from './Permission';

export type UserResponse = {
  statusCode: number;
  data: {
    user: User;
  };
};

export enum LLTypes {
  SMB = 'SMB',
  Institutional = 'Institutional',
}

export type Account = {
  metadata: {
    monolith_id: string;
  };
};

export type Company = {
  hubspot_parent_company_id: string;
  is_active: boolean;
  operator_company_id: string;
  operator_company_marketing_name: string;
};

export interface AxiosUserResponse {
  data: UserResponse;
}

export type User = {
  email: string;
  lastName?: string;
  firstName?: string;
  fullName?: string;
  id?: string;
  phone?: string;
  ownedUnits?: number;
  status?: UserStatus;
  propertyLLC?: string;
  hdyhearAboutUs?: string;
  partner?: string;
  role: string;
  sizeOfPortfolio: sizeOfPortfolio;
  sizeOfPortfolioOld: sizeOfPortfolio;
  isAccountAdmin: boolean;
  setPasswordLink?: string;
  isSMB?: boolean;
  LLType: LLTypes;
  canEnrollProperties?: boolean;
  account: Account;
  foundAln?: {
    source: string;
    companyId: string;
    numberOfProperties: number;
    companyName: string;
  };
  company?: Company;
  userPermissions: Permission[];
  newDealsDashboardAccess: boolean;
  claimsReportAccess: boolean;
  newClaimsFormAccess: boolean;
};
